import React from "react";
import { Backdrop, CircularProgress, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  solid: {
    color: "#286f8c",
    background: "#28aecb",
  },
  transparent: {
    color: "white",
    margin: "0 !important",
    zIndex: 1001,
  },
  logo: {
    width: 200,
  },
}));

const LoadingIndicator = ({ transparent }) => {
  const classes = useStyles();
  return (
    <Backdrop
      className={transparent ? classes.transparent : classes.solid}
      open={true}
    >
      <Grid
        container
        spacing={1}
        direction="column"
        alignContent="center"
        alignItems="center"
      >
        <Grid item>
          <CircularProgress color="inherit" />
        </Grid>
      </Grid>
    </Backdrop>
  );
};

export default LoadingIndicator;
